import jwt_token from 'jwt-decode'
import storage from '../../config/local-storage'

export default {
	'SET_SESSION' (state, token) {

		if(token == null){
			sessionStorage.removeItem(storage.localSession)
			state.user = null

		} else {
			let dados = jwt_token(token);
			let user = {
				token: token,
				id: dados.id,
				nome: dados.nome,
				login: dados.login,
				exp: dados.exp,
				privs: dados.privs,
				foto: dados.foto,
			}

			state.user = user

			var string = JSON.stringify(user)
			sessionStorage.setItem(storage.localSession, string)
		}
	},

	'SET_BASE_URL' (state, baseURL) {

		var string = JSON.stringify(baseURL)
		sessionStorage.setItem(storage.localBaseURL, string)
		state.baseURL = baseURL
	},


	'SET_CONFIG' (state, config) {

		var string = JSON.stringify(config)
		sessionStorage.setItem(storage.localConfig, string)
		state.config = config
	},

	'SET_WEBSOCKET' (state, conectado) {
		state.webSocket = conectado
	},

}



// WEBPACK FOOTER //
// ./src/store/sessao/mutations.js